module.exports = __webpack_public_path__ + "static/media/label-app-store.25f697e8.svg";